/**
 * Mapping statut → classes Tailwind (texte + bg). Reproduit la fonction
 * getStatusColor utilisée par tous les composants dashboard Loveable.
 */
export function getStatusColor(status: string): string {
  switch (status.toLowerCase()) {
    case 'en cours':
    case 'en cours de traitement':
      return 'bg-yellow-100 text-yellow-800';
    case 'validé':
    case 'valide':
    case 'signé':
    case 'payée':
    case 'paye':
    case 'terminé':
      return 'bg-green-100 text-green-800';
    case 'en attente':
    case 'à venir':
    case 'en_attente':
      return 'bg-blue-100 text-blue-800';
    case 'refusé':
    case 'refuse':
    case 'échec':
    case 'echec':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}
